import React, { useEffect, useState } from 'react'
import { useRoutes, useLocation } from 'react-router-dom'
import Footer from './partials/Footer/Footer'
import Header from './partials/Header/Header'
import pages from './pages'
import { IntlProvider } from 'react-intl'
import English from './lang/en.json'
import { mapPosition, useCurrentPathColor } from './utils/helpers'
import { HeaderContextProvider } from './partials/Header/components/HeaderContext'
import api from './utils/api'
import convert from 'xml-js'
import { CareersContextProvider } from './templates/Careers/CareersContext'
import { PositionProps } from './templates/Position/utils'
import Cookies from './components/Cookies/Cookies'
import CK from 'js-cookie'
import { twMerge } from 'tailwind-merge'

function App() {
    const headerColor = useCurrentPathColor()
    const [headerMargin, setMarginHeader] = useState(0)
    const [isHeaderHovered, setIsHeaderHovered] = useState(false)
    const [openings, setOpenings] = useState<PositionProps[]>([])
    const [freePosition, setFreePosition] = useState<PositionProps | null>(null)
    const [showCookies, setShowCookies] = useState(true)

    useEffect(() => {
        window.history.scrollRestoration = 'manual'
    }, [])

    useEffect(() => {
        api.get('/wp-json/jobs/v1/jobs').then((response) => {
            const positions = JSON.parse(
                convert.xml2json(response.data.body, { compact: true, spaces: 2 }),
            )['workzag-jobs'].position
            setFreePosition(
                mapPosition(
                    positions.find(
                        (position: { department: { _text: string } }) => position.department._text === 'Other',
                    ),
                ),
            )
            setOpenings(
                positions
                    .filter(
                        (position: { department: { _text: string } }) => position.department._text !== 'Other',
                    )
                    .map(mapPosition),
            )
        })
    }, [])

    useEffect(() => {
        const value = CK.get('cookies')
        if (value) {
            setShowCookies(false)
        }
    }, [])

    const location = useLocation()

    const element = useRoutes(pages)
    if (!element) return null

    const originalTitle = 'Biomatter | Protein Architects'
    const originalUrl = 'https://biomatter.ai'
    const originalImage = 'https://biomatter.ai/wp-content/uploads/2023/02/biomatter-preview.png'

    let title = originalTitle
    let url = originalUrl
    let image = originalImage

    const metaOgTitle = document.querySelector('meta[property="og:title"]')
    const metaOgUrl = document.querySelector('meta[property="og:url"]')
    const metaOgImage = document.querySelector('meta[property="og:image"]')

    if (location && (location.pathname === '/lynx' || location.pathname === '/lynx/')) {
        title = 'Biomatter | LYNX Enzyme Optimization™'
        url = 'https://biomatter.ai/lynx/'
        image = 'http://biomatter.ai/wp-content/uploads/2024/03/biomatter-lynx-preview.png'
    }

    document.title = title
    metaOgTitle && metaOgTitle.setAttribute('content', title)
    metaOgUrl && metaOgUrl.setAttribute('content', url)
    metaOgImage && metaOgImage.setAttribute('content', image)

    return (
        <div className='relative will-change-scroll overflow-x-hidden'>
            <IntlProvider locale={'en'} messages={English}>
                {/*<ScrollToTop />*/}
                <HeaderContextProvider
                    value={{ isHeaderHovered, setIsHeaderHovered, headerColor, headerHeight: headerMargin }}
                >
                    <div
                        style={{ opacity: isHeaderHovered ? '1' : '0' }}
                        className={twMerge(
                            'w-full h-full bg-black/30 absolute top-0 transition duration-300',
                            isHeaderHovered ? 'z-20' : 'z-0',
                        )}
                    />
                    <div
                        className='w-screen transition ease-out duration-500 relative'
                        style={{ backgroundColor: headerColor }}
                    >
                        <CareersContextProvider value={{ openings, freePosition }}>
                            <Header setMarginHeader={setMarginHeader} />
                            <div>{React.cloneElement(element)}</div>
                            <Footer />
                        </CareersContextProvider>
                    </div>
                </HeaderContextProvider>
                {showCookies && <Cookies setShowCookies={setShowCookies} />}
            </IntlProvider>
        </div>
    )
}

export default App
